import { graphClient } from '../graph-client'
import type { LiveCheckinLevelReward } from '../../types/check-in'
import type { Response } from '../../types/response'
import { GET_LIVE_CHECKIN_LEVELS_REWARDS } from './gql'

export namespace GetList {
  export interface Input {
    take?: number
    skip?: number
    liveCheckinLevelId?: number
    active?: boolean
    deleted?: boolean
  }
  export interface Output {
    getLiveCheckinLevelsRewards: Response<LiveCheckinLevelReward[]>
  }
}

class LiveCheckinLevelsRewardsService {
  async getList(params: GetList.Input) {
    const res = await graphClient.request<GetList.Output>(
      GET_LIVE_CHECKIN_LEVELS_REWARDS,
      params,
    )
    return res?.getLiveCheckinLevelsRewards
  }
}

export const liveCheckinLevelsRewardsService = new LiveCheckinLevelsRewardsService()
